(() => {
  window.TNMarketing = {
    cartSubtotal(cart) {
      return (cart.items || []).reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
    },
    cartLine(item, money, escape) {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="tn-cart-variant">${escape(item.variant_title)}</p>` : '';
      const oldPrice = item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : '';
      const quantity = item.quantity || 1;
      const unitPrice = Number.isFinite(item.final_price) ? item.final_price : item.final_line_price / quantity;
      return `${variant}<small class="tn-cart-unit-price">${money(unitPrice)} × ${quantity} adet</small><p>${oldPrice}${money(item.final_line_price)}</p>`;
    },
    cartSavings(cart, money) {
      return cart.total_discount > 0 ? `<div class="tn-cart-savings"><span>Uygulanan indirim</span><strong>−${money(cart.total_discount)}</strong></div>` : '';
    }
  };
  const initializeGuide = guide => {
    if (guide.dataset.enhanced) return;
    const tabs = [...guide.querySelectorAll('[data-occasion-tab]')];
    const panels = [...guide.querySelectorAll('[data-occasion-panel]')];
    if (!tabs.length) return;
    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== index; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tabs[i].id); });
      if (focus) tabs[index].focus();
    };
    guide.querySelector('[role="tablist"]').hidden = false;
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(next, true); }
      });
    });
    guide.dataset.enhanced = 'true';
    activate(0);
  };
  document.querySelectorAll('[data-shopping-guide]').forEach(initializeGuide);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-shopping-guide]').forEach(initializeGuide);
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-copy-offer]');
    if (!button) return;
    const status = button.closest('.tn-first-order').querySelector('[data-offer-status]');
    try {
      await navigator.clipboard.writeText(button.dataset.copyOffer);
      status.textContent = 'Kod kopyalandı. Ödeme adımında kullanabilirsiniz.';
    } catch (_) {
      status.textContent = `Ödeme adımındaki indirim alanına ${button.dataset.copyOffer} yazın.`;
    }
  });
})();
